var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7252 0H2.27409C1.01458 0 -0.000366211 1.21266 -0.000366211 2.71753V11.2825C-0.000366211 12.7873 1.01458 14 2.27409 14H15.7252C16.9847 14 17.9996 12.7873 17.9996 11.2825V2.71753C17.9996 1.21266 16.9847 0 15.7252 0ZM15.3706 1.75325L8.99963 5.87662L2.62871 1.75325H15.3706ZM15.7252 12.2468H2.27409C1.83387 12.2468 1.46703 11.8084 1.46703 11.2825V2.89286L8.54719 7.68831C8.6817 7.80519 8.84067 7.87825 8.99963 7.87825C9.1586 7.87825 9.31757 7.8198 9.45208 7.68831L16.5322 2.89286V11.2825C16.5322 11.8231 16.1654 12.2468 15.7252 12.2468Z",
    fill: "url(#paint0_linear_0_32)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_32",
    x1: -5.79704,
    y1: 13.7549,
    x2: 6.76105,
    y2: -9.87407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon-7.095aa6426247f86026c1392847bb6d95.svg";
export { ForwardRef as ReactComponent };